<div class="p-4 flex flex-col gap-4">
  <p class="text-sm text-gray-600">Complétez le paiement dans la fenêtre ci-dessous.</p>
  @if (checkoutLinkUrl) {
    <div class="border border-gray-200 rounded-lg overflow-hidden bg-white" style="min-height: 500px;">
      <iframe
        [src]="checkoutLinkUrl | safe"
        title="Paiement"
        class="w-full border-0"
        style="height: 500px;">
      </iframe>
    </div>
  } @else {
    <p class="text-sm text-red-600">Lien de paiement indisponible.</p>
  }
  <div class="flex justify-end">
    <button
      type="button"
      (click)="close()"
      class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors text-sm">
      Fermer
    </button>
  </div>
</div>
